import { PLATFORM_LOCALE_FALLBACK_ORDER, type LocalizedString } from '@web-studio/shared-schemas';

const FALLBACK_LOCALES = PLATFORM_LOCALE_FALLBACK_ORDER;

/**
 * Resolve a localized string for the active locale.
 *
 * - If the locale key is present (including `""`), that value wins — empty means
 *   the owner cleared the field and must render blank (no cross-locale fallback).
 * - If the locale key is missing, fall back through PLATFORM_LOCALE_FALLBACK_ORDER,
 *   then any non-empty value in the map.
 */
export function pickLocalized(
  map: LocalizedString | undefined,
  locale: string,
  fallbacks: readonly string[] = FALLBACK_LOCALES,
): string {
  if (!map) return '';
  const direct = map[locale];
  if (typeof direct === 'string') return direct;
  for (const key of fallbacks) {
    const value = map[key];
    if (typeof value === 'string' && value.length > 0) return value;
  }
  const first = Object.values(map).find((v): v is string => typeof v === 'string' && v.length > 0);
  return first ?? '';
}

export function pickBlockField(
  content: Record<string, LocalizedString>,
  key: string,
  locale: string,
): string {
  return pickLocalized(content[key], locale);
}
